export class lll {
  getOptions() {
    return {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    };
  }
}


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/core/i18n/date/MonthNameShortDayMonthYearTime.js
 **/